export default __webpack_public_path__ + "static/media/section2b-grid4img.860bf903.svg";